import {
  handleAPIErrors,
  handleNullResponse
} from "../redux/Handlers/ErrorHandlers";
import Resources from "../Resources.json"
export const headersJsonToken = {
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization: "Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IndjNkQzTkIwZWlMOXZZRGNadlVOdFEiLCJ0eXAiOiJhdCtqd3QifQ.eyJuYmYiOjE3NDg0MTk3ODUsImV4cCI6MTc0ODQ0ODU4NSwiaXNzIjoiaHR0cDovL2lkZW50aXR5c2VydmljZS5jb3J1c2NhbnQucmVwdWJsaWNhLmxvY2FsOjUwMDAiLCJhdWQiOiJSZXB1YmxpY2FSZXNvdXJjZSIsImNsaWVudF9pZCI6ImNsaWVudCIsInN1YiI6ImVjMzBlNzU1LWJiNzktNDVmZi1iODI2LTdmZWY2NDJlNzgyZCIsImF1dGhfdGltZSI6MTc0ODQxOTc4NSwiaWRwIjoibG9jYWwiLCJ1c2VyTmFtZSI6ImRtYSIsInNjb3BlIjpbIlJFUFVCTElDQV9TRVJWSUNFUyJdLCJhbXIiOlsicHdkIl19.Ue8g_C7h2Ie3ZbLedwkfRDg3WqWWqC_4WPPFH4Tz0Q4obB0n4uEMtPp4kpi8RFW39iroQuazTJBeeTbhxfCpaJ1QtVDd88I5oPjx3xl0Ai-xRu6m9USt_PF5jPIg-Xa8XobH-TjnuCYi72RnGVq8EFLXI6fSCIk1q0mhklCtoFtA0gXtfuo_ycoqiKEujM860hgh3QuSUgVLKwPmAFe3uE2zLOA-6AWgjOXUvTU2j-TULtf1FzTZiGNMMGj0LebCrKLuICfJjnW7lF5elP4hI-CsFvOGIG9v7Ji5Mai6kYmSRFgBGX0vROlAyQcU0En-49MoyP_hcPPQGEuNfuAw_g",
  "x-organization-id": "1" 
};



export async function _request(options) {

  const {
    method,
    endpoint,
    body,
    sendError,
    callbackError,
    callbackSucceed,
    acceptNull = false,
    sendHeader = true,
    skipErrorNotification,
    skipBodyParsing,
    throwError,
    headers
  } = options;

  


  try {
    let response = await fetch(endpoint, {
      method,
      headers: headers || (sendHeader ? headersJsonToken : undefined),
      body
    });

    await handleAPIErrors(response);

    let json = undefined;

    if (!skipBodyParsing) {
      json = await handleNullResponse(response, acceptNull)
    }

    // Handle requests without body
    if (skipBodyParsing &&
      !(response instanceof Response && response.ok && (response.status === 200 || response.status === 204))) {
      if (typeof callbackError !== "function") {
        throw new Error();
      }

      callbackError();

      return;
    }

    if (typeof callbackSucceed === "function") {
      callbackSucceed(json);
    }

    return json;
  } catch (error) {
    if (sendError !== false) {
      //handleAPIErrorNotification(endpoint, error, skipErrorNotification);
    }

    if (typeof callbackError === "function") {
      callbackError(error);
    }

    if (throwError) {
      throw(error);
    }
  }

  // On catch.
  return undefined;
}

export async function fetchGetWT(endpoint, callbackSucceed, callbackError, sendError, acceptNull = false) {
  return await _request({
    method: "GET",
    endpoint,
    callbackSucceed,
    callbackError,
    sendError,
    acceptNull
  });
}

export async function fetchGet(endpoint, callbackSucceed, callbackError, sendError) {
  return await _request({
    method: "GET",
    endpoint,
    callbackSucceed,
    callbackError,
    sendHeader: false,
    sendError
  });
}

export async function fetchPostWT(endpoint, body, callbackSucceed, callbackError, skipErrorNotification) {
  return await _request({
    method: "POST",
    endpoint,
    body,
    callbackSucceed,
    callbackError,
    skipErrorNotification
  });
}

export async function fetchPostWTNoBodyResponse(endpoint, body, callbackSucceed, callbackError) {
  return await _request({ method: "POST", endpoint, body, callbackSucceed, callbackError, skipBodyParsing: true });
}

export async function fetchPostFormDataWT(endpoint, form, callbackSucceed, callbackError) {
  const headers = {
    Accept: "application/json, application/xml, text/plain, text/html, *.*",
    Authorization: "Bearer " + getToken(),
    "x-organization-id": "1" 
  };
  return await _request({ method: "POST", endpoint, body: form, callbackSucceed, callbackError, headers });
}

export function fetchPostMSingleFileMultipartDataWT(
  endpoint,
  file,
  callbackSucced,
  callbackError
) {

  const formData = new FormData();
  formData.append('file', file);

  let options = {
    Accept: "application/json, application/xml, text/plain, text/html, *.*",
    Authorization: "Bearer " + getToken(),
    "x-organization-id": "1" 
  };

  return fetch(endpoint, {
    method: "POST",
    headers: options,
    body: formData
  })
    .then(handleAPIErrors)
    .then(handleNullResponse)
    .then(json => {
      callbackSucced(json);
      return json;
    })
    .catch(error => {
     // handleAPIErrorNotification(endpoint, error);
      callbackError(error);
    });
}

export async function fetchPutWT(endpoint, body, callbackSucceed, callbackError) {
  return await _request({ method: "PUT", endpoint, body, callbackSucceed, callbackError });
}

export async function fetchPatchWT(endpoint, body, callbackSucceed, callbackError, skipBodyParsing = false) {
  return await _request({ method: "PATCH", endpoint, body, callbackSucceed, callbackError, skipBodyParsing });
}

export async function fetchDeleteWT(endpoint, body, callbackSucceed, callbackError) {
  return await _request({ method: "DELETE", endpoint, body, callbackSucceed, callbackError });
}

export async function fetchDeleteWTNoBodyResponse(endpoint, body, callbackSucceed, callbackError) {
  return await _request({ method: "DELETE", endpoint, body, callbackSucceed, callbackError, skipBodyParsing: true });
}